"use strict";
import "../../api/account";
import classNames from "classnames";
import DocumentThumbnailList from "../document_thumbnail_list";
import "../popout";
import LoadIdAndStatus from "./load_id_and_status";
import { History } from "react-router";
import Auth from "../../util/auth";
import AddDocumentToLoad from "./add_document_to_load";
const DocumentGroupList = React.createClass({
  propTypes: {
    isConfirmAndSubmit: React.PropTypes.bool,
    onPageSelected: React.PropTypes.func.isRequired,
    groups: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    collapseSingleGroup: React.PropTypes.bool,
    selectedPage: React.PropTypes.object.isRequired,
    onContextMenu: React.PropTypes.func,
    location: React.PropTypes.object.isRequired,
    loadState: React.PropTypes.object,
    carrierInvoice: React.PropTypes.object
  },
  mixins: [History],
  selectGroup: function(group) {
    this.props.onPageSelected(group.documents[0].pages[0]);
  },
  // taking a collection and turning into a single page
  // since the thumbnail list handles collections and this component
  // doesn't use them them yet
  pageSelected: function(pages) {
    this.props.onPageSelected(pages[0]);
  },
  componentDidMount: function() {
    const list = ReactDOM.findDOMNode(this.refs.list);
    this.baseHeight = list.offsetHeight;
    const first_child = [...list.children].find((node) => node.className !== "document-browser__add-document-wrapper");
    this.topOffset = $(first_child.children[0]).offset().top + 120;
  },
  componentDidUpdate: function() {
    const list = ReactDOM.findDOMNode(this.refs.list);
    const offset = $(".document-thumbnail__page--selected").offset();
    if (offset) {
      const currentScroll = list.scrollTop;
      list.scrollTop = currentScroll + offset.top - this.topOffset;
    }
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { ref: "list", className: "document-browser__document-list" }, /* @__PURE__ */ React.createElement(
      AddDocumentToLoad,
      {
        isConfirmAndSubmit: this.props.isConfirmAndSubmit,
        loadState: this.props.loadState,
        carrierInvoice: this.props.carrierInvoice
      }
    ), this.showThumbnailListOrGroups());
  },
  showThumbnailListOrGroups: function() {
    if (this.props.groups.length === 1 && this.props.collapseSingleGroup) {
      return this.showThumbnailList(this.props.groups[0]);
    }
    const groupedByDoctype = !!Auth._currentUser.account.settings.documents_viewer_doctype_grouping_enabled && this.props.groups.every((group) => this.isGroupedByDocBatch(group));
    if (groupedByDoctype) {
      return this.showCombinedGroups();
    }
    return /* @__PURE__ */ React.createElement("div", null, _.map(this.props.groups, this.showGroup));
  },
  showCombinedGroups: function() {
    const documents = _.flatten(_.map(this.props.groups, (group) => group.documents));
    return /* @__PURE__ */ React.createElement(
      DocumentThumbnailList,
      {
        documents,
        collapseSingleGroup: this.props.collapseSingleGroup,
        onContextMenu: this.onContextMenu(this.props.groups[0]),
        setSelectedPages: this.pageSelected,
        selectedPages: this.selectedPages()
      }
    );
  },
  showThumbnailList: function(group) {
    return /* @__PURE__ */ React.createElement(
      DocumentThumbnailList,
      {
        documents: group.documents,
        relatedDocuments: group.relatedDocuments,
        relatedDocumentsTitle: group.relatedDocumentsTitle,
        relatedDocumentsLoading: group.relatedDocumentsLoading,
        collapseSingleGroup: this.props.collapseSingleGroup,
        onContextMenu: this.onContextMenu(group),
        setSelectedPages: this.pageSelected,
        selectedPages: this.selectedPages()
      }
    );
  },
  // shim turning the single page into a collection since
  // the thumbnail list only handles collections
  // and this component doesn't use multiple selected pages yet
  selectedPages() {
    return [this.props.selectedPage];
  },
  onContextMenu: function(group) {
    if (this.props.onContextMenu) {
      return _.partial(this.props.onContextMenu, group);
    }
  },
  isGroupedByDocBatch: function(group) {
    const isGroupable = group.url || group.name == "Uploaded Documents";
    return isGroupable && this.props.isConfirmAndSubmit;
  },
  showSelectedGroup: function(group) {
    const showGroupHeading = !Auth._currentUser.account.settings.documents_viewer_doctype_grouping_enabled || !this.isGroupedByDocBatch(group);
    let classes = "document-browser__list-item";
    if (group.groupType) {
      classes += " document-browser__list-item--" + group.groupType;
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classes,
        key: group.number
      },
      showGroupHeading && /* @__PURE__ */ React.createElement(
        "h6",
        {
          onClick: () => this.groupClicked(group),
          className: "document-browser__group-heading"
        },
        this.groupHeading(group)
      ),
      this.showThumbnailList(group)
    );
  },
  groupHeading: function(group) {
    if (this.isGroupedByDocBatch(group) && group.url) {
      const isIndexAuditSplitEnabled = !!Auth._currentUser.account.settings.index_audit_split_enabled;
      if (isIndexAuditSplitEnabled) {
        return "Re-index ";
      } else {
        return "View Email";
      }
    } else {
      return group.name;
    }
  },
  groupClicked: function(group) {
    if (group.url && !group.areLoadDocuments) {
      const invoiceId = group.documents[0].carrier_invoice_id || group.documents[0].factor_invoice_id;
      const onDone = this.props.location.query.onDone || "/dashboard";
      this.history.pushState(null, group.url, { invoiceId, onDone });
    } else if (group.url && group.areLoadDocuments) {
      const onDone = this.props.location.query.onDone || "/dashboard";
      this.history.pushState(null, group.url, { onDone });
    }
  },
  showGroup: function(group) {
    if (group.selected) {
      return this.showSelectedGroup(group);
    }
    return this.showCollapsedGroup(group);
  },
  showCollapsedGroup: function(group) {
    const hash = {};
    hash["document-browser__collapsed-list"] = true;
    hash["document-browser__ignored"] = group.ignored;
    const classes = classNames(hash);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "document-browser__list-item",
        key: group.number,
        title: "Go to next group - Alt+G\nGo to previous group - Alt+Shift+G"
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classes,
          onClick: () => this.selectGroup(group)
        },
        /* @__PURE__ */ React.createElement("h6", null, group.name, /* @__PURE__ */ React.createElement("a", { className: "document-browser__collapsed-list-link" })),
        /* @__PURE__ */ React.createElement("div", { className: "document-browser__collapsed-list-documents" }, group.documents.length, " documents")
      ),
      /* @__PURE__ */ React.createElement(LoadIdAndStatus, { group })
    );
  }
});
export default DocumentGroupList;
